"use strict";
"use client";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _grid = require("../grid");
var _default = exports.default = _grid.Row;